import { useAxios } from '../../config/axios'
import { jobItemOutput } from './output/job.item.output'
import { jobListOutput } from './output/job.list.output'

import { getConfig } from './config'

const useApiJobsExternalProvider = async (payload) => {
  const {
    endpoint = 'jobs',
    method = 'get',
    params = {},
    url = '',
    locale = 'pt-br',
  } = payload

  const config = getConfig({ ...payload })
  const { baseURL, boards, endpoints } = config

  const result = await useAxios({
    baseURL: `${baseURL}${boards[locale.slice(0, 2)]}`,
    headers: { ...payload.headers, ...config.headers },
    endpoint: `${endpoints[endpoint]}${url}`,
    method,
    params,
  })

  if (result) {
    if (result.hasOwnProperty('jobs')) {
      return jobListOutput({ data: result.jobs, locale })
    }

    return jobItemOutput({ data: result, locale })
  }
}

export { useApiJobsExternalProvider }
